import { AtomEffect } from 'recoil'

/* eslint-disable prettier/prettier */
export const localStorageEffect =
  <T>(key: string): AtomEffect<T> =>
    ({ onSet, setSelf }) => {
      const savedValue = localStorage.getItem(key)
      if (savedValue != null) {
        setSelf(JSON.parse(savedValue))
      }

      onSet((newValue, _, isReset) =>
        isReset ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(newValue))
      )
    }
